export const getNavigationUuids = ({ files, uuid } = {}) => {
  if (!files?.length || !uuid) {
    return {
      nextUuid: null,
      previousUuid: null,
      nextFile: null,
    };
  }

  const index = files.findIndex((item) => item.uuid === uuid);

  if (index === -1) {
    return {
      nextUuid: null,
      previousUuid: null,
      nextFile: null,
    };
  }

  const hasPrevious = index > 0;
  const hasNext = index < files.length - 1;

  const previousFile = hasPrevious ? files[index - 1] : null;
  const nextFile = hasNext ? files[index + 1] : null;

  return {
    previousUuid: previousFile?.uuid || null,
    nextUuid: nextFile?.uuid || null,
    nextFile,
  };
};

export const getNavigationUrls = ({ files, uuid, getFileUrl }) => {
  const { nextUuid, previousUuid, nextFile } = getNavigationUuids({
    files,
    uuid,
  });

  return {
    nextUrl: nextUuid ? getFileUrl(nextUuid) : '',
    previousUrl: previousUuid ? getFileUrl(previousUuid) : '',
    nextFile,
  };
};
